export default (theme) => ({
  footerText: {
    color: theme.palette.text.main,
    fontSize: 14,
    fontWeight: '300',
    lineHeight: '20px',
    margin: 0,
  },
});
